<template>
	<div class="forgotPassword_box">
		<el-form :model="forgotPasswordForm" :rules="forgotPasswordRules" ref="registerRuleForm" label-width="140px" class="demo-registerRuleForm" label-position="left">
			<el-form-item label="用户账号" prop="userName">
				<el-input v-model="forgotPasswordForm.userName" placeholder="请输入用户账号" :disabled="phone ? true : false"></el-input>
			</el-form-item>
			<el-form-item label="验证码" prop="check">
				<div class="verification_code flex-be">
					<el-input class="m-r-5" v-model="forgotPasswordForm.check" placeholder="请输入验证码"></el-input>
					<el-button @click="sendVerifyEmailFunc()">验证码</el-button>
					<!-- <smsSend :mobile="forgotPasswordForm.phoneNumber" :sms-type="smsType"></smsSend> -->
				</div>
			</el-form-item>
			<el-form-item label="设置密码" prop="pwd">
				<el-input type="password" v-model="forgotPasswordForm.pwd" placeholder="密码6-16位，区分大小写" show-password></el-input>
			</el-form-item>
			<div class="submit_btn_box m-t-30">
				<el-button type="primary" style="width: 100%" @click="submitForm('registerRuleForm')"> 提 交 </el-button>
			</div>
		</el-form>
	</div>
</template>

<script>
import smsSend from '@/components/SmsSend'
import crypto from '@/utils/Crypto'

export default {
	name: 'forgotPassword',
	props: ['address', 'phone', 'smsType'],
	// import引入的组件需要注入到对象中才能使用
	components: {
		smsSend
	},
	data() {
		// 这里存放数据
		var validatePass = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入密码'))
			} else if (value.length < 6 || value.length > 16) {
				callback(new Error('密码必须在6位到16位之间!'))
			} else {
				callback()
			}
		}
		return {
			forgotPasswordForm: {
				userName: '',
				check: null,
				pwd: '',
				smsType: ''
			},
			forgotPasswordRules: {
				userName: [{ required: true, message: '请输入用户账号', trigger: 'blur' }],
				check: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
				pwd: [{ required: true, validator: validatePass, trigger: 'blur' }]
			}
		}
	},
	// 生命周期 - 创建完成（可以访问当前this实例）
	created() {
		// 接口地址
		this.interfaceAddress = this.address
		console.log(this.phone)
		this.forgotPasswordForm.phoneNumber = this.phone
	},
	// 方法集合
	methods: {
		async sendVerifyEmailFunc() {
			let resEmail = await this.$http.get(this.$const.common.sendVerifyEmail + `?num=${this.forgotPasswordForm.userName}`)
			console.log(resEmail)
		},
		submitForm(formName) {
			this.forgotPasswordForm.smsType = this.smsType
			console.log(this.forgotPasswordForm)
			this.$refs[formName].validate(async (valid) => {
				if (valid) {
					try {
						this.forgotPasswordForm.loginPassword = crypto.encrypt(this.forgotPasswordForm.pwd)
						// this.forgotPasswordForm.pwd = crypto.encrypt(this.forgotPasswordForm.pwd)
						console.log(this.forgotPasswordForm)

						// if (resEmail && resEmail.code == 200) {
						// this.loading = false
						// this.$message.success(this.$PubText.smsSuccess)
						// this.countdown()
						let res = await this.$http.get(this.interfaceAddress, this.forgotPasswordForm)
						if (res && res.code == 200) {
							await this.$message.success(this.$PubText.successCom)
							await this.$emit('forgotPasswordSuccess')
						}
						// }
					} catch (e) {
						console.log(e)
					}
				} else {
					return false
				}
			})
		}
	}
}
</script>

<style lang="scss" scoped>
.forgotPassword_box {
	width: 100%;

	/deep/ .el-form-item {
		padding-left: 5px;
		padding-right: 0;
		border: 1px solid #409eff;

		.el-input {
			input {
				//background-color: rgba(255, 255, 255, 0.7);
				background-color: transparent;
				border: none;
				padding: 0;
				border-radius: 0;

				&:hover {
					border-color: #409eff;
				}

				&::placeholder {
					color: #5c5c5c;
				}
			}
		}
	}

	.verification_code {
		width: 100%;
		height: 40px;
	}

	.submit_btn_box {
		width: 100%;
		height: 60px;
		text-align: center;
	}
}
</style>